import { render, staticRenderFns } from "./forget-pass.vue?vue&type=template&id=3bd94340"
import script from "./forget-pass.vue?vue&type=script&lang=js"
export * from "./forget-pass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports